module.exports = __webpack_public_path__ + "media/buy-now/crema-cash-1-faa15a67.png";